import gql from 'graphql-tag';

import type { EoiContext } from 'bundles/expression-of-interest/types';

type ResponseKey = 'emailAddress' | 'firstName' | 'lastName' | 'phoneNumber';

type ResponseText = {
  text: string;
};

export type RetrieveCompletedSurveyResponse = {
  QualificationSurveySectionResponse: {
    completionTimestamp?: number;
    isComplete: boolean;
    lastUpdatedTimestamp: number;
    responses: Record<ResponseKey, Record<string, ResponseText>>;
    sectionIds: string[];
    trackingFields?: Record<string, unknown>;
  };
};

export type RetrieveCompletedSurveyVariables = {
  productId: string;
  lookbackPeriodInMonths: number;
  eoiContext: EoiContext;
};

/**
 * @deprecated This's only used within the xddp bundle. Please move it to that bundle.
 */
export const RETRIEVE_COMPLETED_QUALIFICATION_SURVEY = gql`
  mutation RetrieveCompletedQualificationSurvey(
    $productId: String!
    $lookbackPeriodInMonths: Int!
    $eoiContext: DataMap!
  ) {
    QualificationSurveySectionResponse(
      productId: $productId
      input: { eoiContext: $eoiContext, lookbackPeriodInMonths: $lookbackPeriodInMonths }
    )
      @rest(
        type: "QualificationSurveySectionResponsesV2"
        path: "qualificationSurveySectionResponses.v2?action=retrieveCompletedQualificationSurvey&productId={args.productId}"
        method: "POST"
      ) {
      lastUpdatedTimestamp
      isComplete
      lastUpdatedTimestamp
      responses
      sectionIds
      trackingFields
    }
  }
`;

/**
 * @deprecated This's only used within the degree-description bundle. Please move it to that bundle.
 */
export const GET_COMPLETED_QUALIFICATION_SURVEY = gql`
  query GetCompletedQualificationSurvey($productId: String!, $lookbackPeriodInMonths: Int!, $eoiContext: DataMap!) {
    QualificationSurveySectionResponse(
      productId: $productId
      input: { eoiContext: $eoiContext, lookbackPeriodInMonths: $lookbackPeriodInMonths }
    )
      @rest(
        type: "QualificationSurveySectionResponsesV2"
        path: "qualificationSurveySectionResponses.v2?action=retrieveCompletedQualificationSurvey&productId={args.productId}"
        method: "POST"
      ) {
      lastUpdatedTimestamp
      isComplete
      lastUpdatedTimestamp
      responses
      sectionIds
      trackingFields
    }
  }
`;
